import { G } from '@mobily/ts-belt';

export function isEmailMatchingAtLeastOneDomain(email: string, domains: string[] | undefined) {
  if (!domains || domains.length === 0) {
    return true;
  }

  return domains
    .map((domain) => G.isNotNullable(email.trim().match(`@${domain}$`)))
    .reduce((isMatchingDomain, value) => isMatchingDomain || value, false);
}

export const validateEmailWithDomains = (domains: string[], message: string) => (value: string) => {
  if (!isEmailMatchingAtLeastOneDomain(value, domains)) {
    return message;
  }

  return undefined;
};
